module.exports = __webpack_public_path__ + "img/experiencia_selecione_vinculo.260597bb.svg";